import React from "react";
import PropTypes from "prop-types";
import { GridColumn, GridRow, Input, Label } from "arv-reactcomponents";

import AddressBlock from "../../AddressBlock";

const SelfShip = props => {
  const { address, data, onChecked, onSelection } = props;
  return (
    <GridRow>
      <GridColumn className="nw-selfship-wrapper">
        <Label key={data.id} htmlFor={`${data.id}-${data.name}`}>
          <Input
            id={`${data.id}-${data.name}`}
            type="radio"
            value={data.name}
            checked={onChecked}
            className="nwc-inp-radio-primary nwc-inp-xs"
            name="returns"
            onChange={() => {
              onSelection(data.name);
            }}
          />
          <div className="nw-selfship-content">
            <span className="nw-selfship-title">{data.displayName}</span>
            <span className="nw-selfship-subtitle">{data.secondaryName}</span>
          </div>
          {onChecked && (
            <div className="nw-selfship-addresswrapper">
              <AddressBlock.component address={address} />
            </div>
          )}
        </Label>
      </GridColumn>
    </GridRow>
  );
};

SelfShip.propTypes = {
  address: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({}).isRequired,
  onChecked: PropTypes.bool.isRequired,
  onSelection: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: SelfShip,
  component: SelfShip,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/SelfShip/index.js